cv.PaginateBehavior = Marionette.Behavior.extend({
    // you can set default options
    // just like you can in your Backbone Models
    // they will be overriden if you pass in an option with the same key
    defaults: {
      container : '.table-list'
    },

    // behaviors have events that are bound to the views DOM
    events: {
      'click .pagination .prev' : 'previousPage',
      'click .pagination .next' : 'nextPage'
    },

    collectionEvents: {
      'reset' : 'collectionReset',
      'request' : 'collectionRequest',
      'sync' : 'collectionSync'
    },

    collectionReset: function(collection){
      if(this.view.collection.num_records > 0){
        this.$(this.options.container).before(cv.Templates['partials/pagination']({
          position : 'top'
        }));
        this.$(this.options.container).after(cv.Templates['partials/pagination']({
          position : 'bottom'
        }));

        this.$('.pagination .caption').html(collection.caption);
        if(collection.params.offset + collection.params.limit < collection.num_records){
          this.$('.pagination a.next').css('display','inline-flex');
        }
        if(collection.params.offset > 0){
          this.$('.pagination a.prev').css('display','inline-flex');
        }
      }
    },

    collectionRequest: function(collection){
      this.$('.pagination').remove();
      this.$('table tbody').html(cv.Templates['table/loader']());
    },

    collectionSync: function(collection){
      this.$('.loader-row').remove();
    },

    previousPage: function(e){
      e.preventDefault();

      this.view.collection.previousPage();
      cv.router.navigate(window.location.pathname.split("/").pop() + '?' + $.param(this.view.collection.params));
    },

    nextPage: function(e){
      e.preventDefault();

      this.view.collection.nextPage();
      cv.router.navigate(window.location.pathname.split("/").pop() + '?' + $.param(this.view.collection.params));
    }
});
